import React from 'react';

import PostList from 'Site/Ui/PostList'
import RLXStore from 'RLX/State/Store';
import ContentController from 'RLX/Controllers/ContentController';
import { getBlogs } from 'RLX/State/Content/ContentActions';

class PostListEditor extends ContentController {
  constructor (props) {
    super(props);
    this.state = {
      ...super.state,
      blogs: getBlogs()
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
  }

  componentDidMount () {
    this.unsubscribe = RLXStore.subscribe(() => {
      const { siteData } = RLXStore.getState();
      const { blogs } = siteData;
      this.setState({ blogs });
    });
  }

  componentWillUnmount () {
    this.unsubscribe();
  }

  static getInitialShape () {
    return {
      props: {
        id: null
      }
    };
  }

  getBlockName () {
    return 'Blog Post Listing';
  }

  getClassName () {
    return 'PostListEditor';
  }

  getFields () {
    const { blogs } = this.state;
    const { content } = this.props;
    const blogOptions = blogs.map(({ id }) => ({ value: id, text: id }));
    return [
      {
        type: 'select',
        options: blogOptions,
        icon: 'book',
        required: true,
        label: 'Blog ID',
        value: content.props.id,
        onChange: this.applyUpdate((id, existing) => {
          const { props } = existing;
          return { ...existing, props: { ...props, id } };
        })
      }
    ]
  }
};

export default PostListEditor;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Editors/PostListEditor.jsx